module.exports = __webpack_public_path__ + "prod/1.42.2/img/banner-bg.287a7e39.png";